export const patientConstants = {
  GETPATIENTS_REQUEST: 'GETPATIENTS_REQUEST',
  GETPATIENTS_SUCCESS: 'GETPATIENTS_SUCCESS',
  GETPATIENTS_FAILURE: 'GETPATIENTS_FAILURE',
};
